var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.WorkerHandler = {
    worker: null,
    // Actions
    send_worker_message: function (msg) {
        if (this.is_idle) {
            this.set_status(this.options.active_text);
        }
        if (this.worker && isNaN(this.worker)) {
            /* istanbul ignore next */
            try {
                if (msg.options && msg.options.arraybuffer instanceof ArrayBuffer) {
                    this.worker.postMessage(msg, [msg.options.arraybuffer]);
                    delete msg.options.arraybuffer;
                } else {
                    this.worker.postMessage(msg);
                }
                delete msg.options;
                delete msg.cmd;
                return true;
            } catch (e) {
                if(!msg.retries) {
                    msg.retries = 1;
                } else {
                    msg.retries++;
                }
                console.warn("Worker Handler: Failed to send message.", e);
                return false;
            }
        } else {
            console.warn("Worker Handler: Worker not available. Worker has been destroyed!");
            return false;
        }
    },
    stop_worker: function () {
        try {
            this.worker.terminate();
            this.fireEvent(this.options.events.worker_terminated, this);
        } catch (e) {
            console.warn("Worker Handler: Unable to terminate worker.", e);
        }
    },
    // Event Listeners
    on_init_timeout: function () {
        if (this.worker && !isNaN(this.worker)) {
            /* istanbul ignore next */
            try {
                var worker = new Worker(this.options.path);
                worker.onmessage = this.on_worker_message.bind(this);
                this.set_worker(worker);
            } catch (e) {
                console.warn("Worker: Failed to load worker!", e);
            }
        }
    },
    on_status_message: function (data) {
        var status = data.options;
        this.fireEvent(this.options.events.worker_status_update, data);
        if (status.online_status) {
            if (this.online_status !== true) {
                // Our online state has changed
                this.online_status = true;
                this.fireEvent(this.options.events.worker_online, this);
            }
            this.set_status(status.status);
            if (status.status === this.options.idle_text) {
                if (this.msg_queue.length) {
                    this.set_status(this.options.active_text);
                    setTimeout(this.send_from_msg_queue.bind(this), this.options.time_to_msg_queue);
                } else {
                    this.clear_active_request();
                    // We have nothing in the queue, lets inform everyone we are idle
                    this.fireEvent(this.options.events.worker_idle, this);
                }
            }
            if (status.status === 'finished') {
                this.fireEvent(this.options.events.worker_finished, this, 1);
            }
        } else {
            this.online_status = false;
            this.destroy();
            this.fireEvent(this.options.events.worker_terminated, this);
        }
    },
    on_worker_message: function (oEvent) {
        if (!oEvent.data || !oEvent.data.worker_id) {
            return false; // Ignore messages without a worker id
        }
        if (!this.worker_id) {
            this.worker_id = oEvent.data.worker_id; // If we have no worker id, lets set it
        }
        if (this.worker_id !== oEvent.data.worker_id) {
            return false;
        }
        if (oEvent.data.cmd === 'status' && oEvent.data.options.status !== this.status) {
            this.on_status_message(oEvent.data);
            return true;
        }

        this.fireEvent(this.options.events.worker_msg_recieved, oEvent);
        if (this.onmessage) {
            this.onmessage(oEvent.data);
        }

        if (oEvent.data.cmd !== "status" && this.active_request) {
            /* istanbul ignore if */
            if (this.active_request.callback) {
                this.active_request.callback(oEvent.data);
            }
            if (this.active_request.one_time_callback) {
                this.active_request.one_time_callback(oEvent.data);
                this.active_request.one_time_callback = null;
                delete this.active_request.one_time_callback;
            }
            /* istanbul ignore if */
            if (oEvent.data.cmd === "data" && this.active_request.data_callback) {
                this.active_request.data_callback(oEvent.data);
            }
        }
        return true;

    },
    on_worker_finished: function () {
        this.clear_active_request();
        this.set_status(this.options.idle_text);
    }
};